import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronLeft, ChevronRight } from "lucide-react";
import api from "@/lib/api";

const track = (b, placement, kind) => {
  const key = `bn-${kind}-${b.id}-${placement}`;
  if (kind === "view" && sessionStorage.getItem(key)) return;
  sessionStorage.setItem(key, "1");
  api.post(`/api/banners/${b.id}/event`, { kind, placement }).catch(() => {});
};

const Slide = ({ b, i, placement }) => {
  const img = <><img src={b.image_url} alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover scale-110 blur-2xl opacity-60" /><img src={b.image_url} alt={b.title || "The ShopAdvisor"} className="absolute inset-0 w-full h-full object-contain" /></>;
  const cls = "relative block w-full aspect-[5/2] max-h-[640px] overflow-hidden";
  const click = () => track(b, placement, "click");
  if (!b.link_url) return <div className={cls} data-testid={`banner-${i}`}>{img}</div>;
  return /^https?:\/\//.test(b.link_url) ? <a href={b.link_url} target="_blank" rel="noreferrer" onClick={click} className={cls} data-testid={`banner-${i}`}>{img}</a>
    : <Link to={b.link_url} onClick={click} className={cls} data-testid={`banner-${i}`}>{img}</Link>;
};

export const BannerSlot = ({ placement = "home", className = "" }) => {
  const [rows, setRows] = useState([]);
  const [idx, setIdx] = useState(0);
  useEffect(() => { api.get("/api/banners", { params: { placement } }).then(r => setRows(r.data)).catch(() => {}); }, [placement]);
  useEffect(() => { if (rows.length <= 1) return; const t = setInterval(() => setIdx(p => (p + 1) % rows.length), 6000); return () => clearInterval(t); }, [rows.length]);
  useEffect(() => { if (rows[idx]) track(rows[idx], placement, "view"); }, [rows, idx, placement]);
  if (!rows.length) return null;
  const go = (d) => setIdx(p => (p + d + rows.length) % rows.length);
  const nav = "absolute top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white rounded-full p-2 shadow transition-colors z-10 hidden sm:block";
  return (
    <section className={`relative w-full bg-slate-950 ${className}`} data-testid={`banner-carousel-${placement}`}>
      {rows.map((b, i) => <div key={b.id} className={`${i === idx ? "block animate-in fade-in duration-700" : "hidden"}`}><Slide b={b} i={i} placement={placement} /></div>)}
      {rows.length > 1 && <>
        <button onClick={() => go(-1)} className={`${nav} left-3 sm:left-6`} data-testid="banner-prev"><ChevronLeft className="w-5 h-5 text-slate-700" /></button>
        <button onClick={() => go(1)} className={`${nav} right-3 sm:right-6`} data-testid="banner-next"><ChevronRight className="w-5 h-5 text-slate-700" /></button>
        <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-2 z-10">{rows.map((_, i) => <button key={i} onClick={() => setIdx(i)} className={`w-2.5 h-2.5 rounded-full shadow transition-colors ${i === idx ? "bg-amber-400" : "bg-white/70"}`} data-testid={`banner-dot-${i}`} />)}</div></>}
    </section>
  );
};
